var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"cts-form-body",on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"cts-wrapper",style:(_vm.flashBackground)})])}
var staticRenderFns = []

export { render, staticRenderFns }